import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LogLevel, OpenIdConfiguration } from "angular-auth-oidc-client";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class ConfigService {

  tenant_path: string;
  constructor(private actRoute: ActivatedRoute) {
    const domain = window.location.hostname;

    let domainArray = domain.split('.');
    if(domainArray.length > 2){
      this.tenant_path = domainArray[0];
    }
    // remove  comment if you want to ant to test tenancy on your system
     else if(domain == "localhost"){
      this.tenant_path = "dev-hub";
    }
  }
  getConfig(): OpenIdConfiguration {
    return {
      /* Your config here */
      authority:environment.authServerUrl ,
      redirectUrl: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      clientId: 'hub-UI',
      scope: 'hub-backend-api openid profile roles email offline_access ',
      responseType: 'code',
      silentRenew: true,
      renewTimeBeforeTokenExpiresInSeconds: 10,
      useRefreshToken: true,
      ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
      // triggerRefreshWhenIdTokenExpired: false, // required when refreshing the browser if id_token is not updated after the first authentication
      // allowUnsafeReuseRefreshToken: true, // this is required if the refresh token is not rotated
      logLevel: LogLevel.Debug,
      customParamsAuthRequest: {
      response_mode: 'fragment',
      tenant: this.tenant_path,
      }
    }

  }

  getTenatPath(){

  }
}

